import { Redirect, Route, Switch } from "react-router-dom";
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

/* Theme variables */
import "./theme/variables.css";
import "../node_modules/@glidejs/glide/dist/css/glide.core.min.css";
import "../node_modules/@glidejs/glide/dist/css/glide.theme.min.css";
import AppTabs from "./AppTabs";
import NotFoundPage from "./pages/NotFoundPage";
import { useLocalStorage } from "./hooks";
import Menu from "./components/Menu";
import { library, playCircle, radio, search } from "ionicons/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faHouse,
  faHouseChimney,
  faCalendarDays,
  faVideo,
  faClipboardCheck,
  faCirclePlus
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

// pages
import Home from "./pages/home/Home";
import Teams from "./pages/teams/teams";
import TeamDetail from "./pages/teamDetail/teamDetail";
import Player from "./pages/player/Player";
import Results from "./pages/results/results";
import Leaders from "./pages/leaders/leaders";
import Score from "./pages/scores/scores";
import Calendar from "./pages/calendar/calendar";
import CalendarDetail from "./pages/calendar/calendar_detail";
import Video from "./pages/videos/videos";

// unfocus icons
import news_icon from "./icon/01_Calendario_Select.svg";
import teams_icon from "./icon/01_Equipos_Select.svg";
import results_icon from "./icon/01_Calendario_Select.svg";
import leaders_icon from "./icon/01_LideresIndv_Select.svg";
import score_icon from "./icon/01_Resultados_Select.svg";
import tabla_posiciones from "./icon/01_TdePosiciones_Select.svg";

import calendar_icon from "./icon/01_Calendario_Select.svg";
import video_icon from "./icon/01_Video_Select.svg";
import trivia_icon from "./icon/01_Trivias_Select.svg";
import home_icon from "./icon/01_Home_Select.svg";
import more_icon from "./icon/01_Mas_Select.svg";

// focus icons
import news_icon_select from "./icon/01_Calendario.svg";
import teams_icon_select from "./icon/01_Equipos.svg";
import results_icon_select from "./icon/01_Calendario.svg";
import leaders_icon_select from "./icon/01_LideresIndv.svg";
import score_icon_select from "./icon/01_Resultados.svg";

import calendar_icon_select from "./icon/01_Calendario.svg";
import video_icon_select from "./icon/01_Video.svg";
import trivia_icon_select from "./icon/01_Trivias.svg";
import home_icon_select from "./icon/01_Home.svg";
import more_icon_select from "./icon/01_Mas.svg";
import Scores from "./pages/scores/scores";
import News from "./pages/news/news";

setupIonicReact();

const App: React.FC = () => {
  useEffect(() => {
    setActivePage(window.location.pathname);
  }, []);

  const [homeIcon, SetHomeIcon] = useState(home_icon);
  const [calendarIcon, SetCalendarIcon] = useState(calendar_icon);
  const [videosIcon, SetVideosIcon] = useState(video_icon);
  const [resultsIcon, SetResultsIcon] = useState(results_icon);
  const [moreIcon, SetMoreIcon] = useState(more_icon);

  // set active icon for the bottom tab
  // default home, 2 calendar, 3 videos, 4 results, 5 more
  function setActiveIcon(activeTab: number = 1) {
    switch (activeTab) {
      case 2:
        SetHomeIcon(home_icon);
        SetCalendarIcon(calendar_icon);
        SetVideosIcon(video_icon);
        SetResultsIcon(results_icon);
        SetMoreIcon(more_icon);
        break;
      case 3:
        SetHomeIcon(home_icon);
        SetCalendarIcon(calendar_icon);
        SetVideosIcon(video_icon);
        SetResultsIcon(results_icon);
        SetMoreIcon(more_icon);
        break;
      case 4:
        SetHomeIcon(home_icon);
        SetCalendarIcon(calendar_icon);
        SetVideosIcon(video_icon);
        SetResultsIcon(results_icon);
        SetMoreIcon(more_icon);
        break;
      case 5:
        SetHomeIcon(home_icon);
        SetCalendarIcon(calendar_icon);
        SetVideosIcon(video_icon);
        SetResultsIcon(results_icon);
        SetMoreIcon(more_icon);
        break;
      default:
        SetHomeIcon(home_icon_select);
        SetCalendarIcon(calendar_icon);
        SetVideosIcon(video_icon);
        SetResultsIcon(results_icon);
        SetMoreIcon(more_icon);
        break;
    }
  }
  // set active icon according to url path
  function setActivePage(url) {
    switch (url) {
      case "/home":
        setActiveIcon(1);
        break;
      case "/calendar":
        setActiveIcon(2);
        break;
      case "/videos":
        setActiveIcon(3);
        break;
      case "/scores":
        setActiveIcon(4);
        break;
      case "/more":
        setActiveIcon(5);
        break;
      default:
        setActiveIcon(1);
    }
  }

  return (
    <IonApp>
      <IonReactRouter>
        <IonTabs>
          <IonRouterOutlet id='main'>
            <Route
              exact
              path='/'
            >
              <Redirect to='/home' />
            </Route>
            <Route
              exact
              path='/home'
            >
              <Home></Home>
            </Route>
            <Route
              exact
              path='/news'
            >
              <News></News>
            </Route>
            <Route
              exact
              path='/teams'
            >
              <Teams></Teams>
            </Route>
            <Route
              exact
              path='/teamdetails'
            >
              <TeamDetail></TeamDetail>
            </Route>
            <Route
              exact
              path='/player'
            >
              <Player></Player>
            </Route>
            <Route
              exact
              path='/results'
            >
              <Results></Results>
            </Route>
            <Route
              exact
              path='/leaders'
            >
              <Leaders></Leaders>
            </Route>
            <Route
              exact
              path='/scores'
            >
              <Scores></Scores>
            </Route>
            <Route
              exact
              path='/calendar'
            >
              <Calendar></Calendar>
            </Route>
            <Route
              exact
              path='/calendar_detail'
            >
              <CalendarDetail></CalendarDetail>
            </Route>
            <Route
              exact
              path='/videos'
            >
              <Video></Video>
            </Route>
            <Route
              exact
              path='/menu'
            >
              <Menu></Menu>
            </Route>
          </IonRouterOutlet>
          <IonTabBar slot='bottom'>
            <IonTabButton
              tab='home'
              href='/home'
              className='ion-text-center'
              onClick={(e) => {
                setActiveIcon(1);
              }}
            >
              <IonIcon
                src={homeIcon}
                font-size='48px'
              />
              <IonLabel>Inicio</IonLabel>
            </IonTabButton>

            <IonTabButton
              tab='calendar'
              href='/calendar'
              className='ion-text-center'
              onClick={(e) => {
                setActiveIcon(2);
              }}
            >
              <IonIcon
                src={calendarIcon}
                font-size='48px'
              />
              <IonLabel>Juegos</IonLabel>
            </IonTabButton>

            <IonTabButton
              tab='videos'
              href='/videos'
              className='ion-text-center'
              onClick={(e) => {
                setActiveIcon(3);
              }}
            >
              <IonIcon
                src={videosIcon}
                font-size='48px'
              />
              <IonLabel>Videos</IonLabel>
            </IonTabButton>

            <IonTabButton
              tab='scores'
              href='/scores'
              className='ion-text-center'
              onClick={(e) => {
                setActiveIcon(4);
              }}
            >
              <IonIcon
                src={tabla_posiciones}
                font-size='48px'
              />
              <IonLabel>Posiciones</IonLabel>
            </IonTabButton>
            <IonTabButton
              tab='menu'
              href='/menu'
              className='ion-text-center'
              onClick={(e) => {
                setActiveIcon(5);
              }}
            >
              <IonIcon
                src={moreIcon}
                font-size='48px'
              />
              <IonLabel>Más</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
